import { config } from "../../../services/config";
import { pivateOptions } from "../../../services/api";

export const getAllCompras = async (q = "") => {
  const url = `${config.URL_API}/usuario/compras?${q}`;
  const response = await fetch(url, pivateOptions('GET'));
  const data = response.json();
  return data;
}

export const getCompra = async (id) => {
  const url = `${config.URL_API}/usuario/compra/${id}`;
  const response = await fetch(url, pivateOptions('GET'));
  
  if (!response.ok) {
    const error = new Error('Error en la petición');
    error.response = {
      status: response.status,
      statusText: response.statusText
    };
    throw error;
  }
  
  const data = await response.json();
  return data;
};

export const downloadTicketPDF = async (ticketId) => {
  const url = `${config.URL_API}/api/tickets/download/${ticketId}`;
  const response = await fetch(url, {
    ...pivateOptions('GET'),
    responseType: 'blob',
  });
  
  if (!response.ok) {
    throw new Error('Error al descargar el ticket');
  }
  
  return response.blob();
}